import { render, staticRenderFns } from "./DashboardSingle.vue?vue&type=template&id=5e89fbfb&scoped=true"
import script from "./DashboardSingle.vue?vue&type=script&lang=js"
export * from "./DashboardSingle.vue?vue&type=script&lang=js"
import style0 from "./DashboardSingle.vue?vue&type=style&index=0&id=5e89fbfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e89fbfb",
  null
  
)

export default component.exports